import { FC, useState } from "react"

import { Tabs } from "components/navigation/Tabs"
import { SETTINGS_TABS } from "components/risk/constants"
import { AutoActionsTab } from "components/risk/settings/AutoActionsTab"
import { BlacklistTab } from "components/risk/settings/BlacklistTab"
import { DuplicateDetectionTab } from "components/risk/settings/DuplicateDetectionTab"
import { RiskLevelsTab } from "components/risk/settings/RiskLevelsTab"

type RiskSettingsTab = "levels" | "duplicates" | "actions" | "blacklist"

const SETTINGS_CONTENT: Record<RiskSettingsTab, FC> = {
  levels: RiskLevelsTab,
  duplicates: DuplicateDetectionTab,
  actions: AutoActionsTab,
  blacklist: BlacklistTab
}

export const RiskSettingsPanel: FC = () => {
  const [settingsTab, setSettingsTab] = useState<RiskSettingsTab>("levels")
  const Content = SETTINGS_CONTENT[settingsTab]

  return (
    <div className="w-full space-y-6">
      <Tabs tabs={SETTINGS_TABS} activeTab={settingsTab} onChange={(key) => setSettingsTab(key as RiskSettingsTab)} variant="underline" />
      <Content />
    </div>
  )
}
